import { IBaseEntity } from "./IBaseEntity";

export interface IPermission extends IBaseEntity {
    applicationId: number;
}

export const GlobalPermissions = {
    systemOwner: "systemOwner",
    Settings: "Settings",
    HazardChange: "HazardChange",
} as const;

export const mPermissions = {
    global: GlobalPermissions,
} as const;

type GlobalPermissionsTypes = typeof GlobalPermissions[keyof typeof GlobalPermissions];
export type mPermissionTypes = GlobalPermissionsTypes;
export type mPermissionModules = keyof typeof mPermissions;
